module.exports = __webpack_public_path__ + "img/list-black-icon.d4832f95.svg";